import { API_HOST } from './app-global-values';
import UserProfile from './user-profile';
import axios from 'axios';

export const httpGet = (path, extraHeaders = {}, params = {}) => {
  return UserProfile.getJwtToken().then(jwt => {
    return axios.get(`${API_HOST}${path}`, {
      headers: {
        Authorization: jwt,
        ...extraHeaders,
      },
      params: params,
      withCredentials: true,
    });
  });
};

export const httpPost = (path, body, extraHeaders = {}) => {
  return UserProfile.getJwtToken().then(jwt => {
    return axios.post(`${API_HOST}${path}`, body, {
      headers: {
        Authorization: jwt,
        ...extraHeaders,
      },
      withCredentials: true,
    });
  });
};

export const httpDelete = (path, body, extraHeaders = {}) => {
  return UserProfile.getJwtToken().then(jwt => {
    return axios.delete(`${API_HOST}${path}`, {
      headers: {
        Authorization: jwt,
        ...extraHeaders,
      },
      data: body,
      withCredentials: true,
    });
  });
};

export const httpPut = (path, body, extraHeaders = {}) => {
  return UserProfile.getJwtToken().then(jwt => {
    return axios.put(`${API_HOST}${path}`, body, {
      headers: {
        Authorization: jwt,
        ...extraHeaders,
      },
      withCredentials: true,
    });
  });
};
